module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Black_MockedUp.980aa3a0.jpg";